export const chartColors: Record<
  'chart' | 'chart-tint' | 'seq' | 'chart-shade',
  {
    1: string;
    2: string;
    3: string;
    4: string;
    5: string;
    6: string;
    'viz-other'?: string;
    'viz-empty'?: string;
    'dark-grey'?: string;
  }
> = {
  chart: {
    1: '#2EBAD7',
    2: '#2B6DC5',
    3: '#62A003',
    4: '#FFB944',
    5: '#7D94FF',
    6: '#FF8E6C',
    'viz-other': '#D4D4D8',
  },
  'chart-tint': {
    1: '#CBEEF5',
    2: '#DAE5F5',
    3: '#D7E7C0',
    4: '#FFEDD0',
    5: '#DFE4FF',
    6: '#FFE3DA',
    'viz-empty': '#E4E4E7',
  },
  'chart-shade': {
    1: '#047289',
    2: '#08498C',
    3: '#467202',
    4: '#C07800',
    5: '#2463C7',
    6: '#C74118',
    'dark-grey': '#71717A',
  },
  seq: {
    1: '#92E2F2',
    2: '#2EBAD7',
    3: '#3AA1F0',
    4: '#7D94FF',
    5: '#4276E1',
    6: '#255BA2',
  },
} as const;

export const categoricalPallete = Object.entries(chartColors.chart)
  .filter(([key]) => key !== 'viz-other')
  .map(([, value]) => value);

export const sequentialPallete = Object.values(chartColors.seq).map(
  (value) => value,
);

export const categoricalTintPallete = Object.entries(chartColors['chart-tint'])
  .filter(([key]) => key !== 'viz-empty')
  .map(([, value]) => value);
